import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentService } from '@app/services/Payment/payment.service';
import { environment } from './../../../../environments/environment.prod';
import Swal from 'sweetalert2';
import { UserService } from '@app/services/User/user.service';
import { User } from '@app/model/user';
import { EmailService } from '@app/services/Email/email.service';
import axios from 'axios';

@Component({
  selector: 'app-price-details',
  templateUrl: './price-details.component.html',
  styleUrls: ['./price-details.component.css']
})
export class PriceDetailsComponent implements OnInit {
  razorPayKey: any;
  Razorpay: any;
  userInfoId:any;
  businessUser:any;
  businessEmail:any;
  phoneNumber:any;
  gender:any;
  firstName:any;
  lastName:any;

  constructor(
    private paymentService: PaymentService,
    private userService: UserService, 
    private emailService:EmailService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}
  
  ngOnInit() {
    this.userInfoId = this.getUUID(); 
    if(!this.userInfoId){
      Swal.fire({
        title: `Please login your profile before activate plan.`,
        icon: "warning",
        showConfirmButton: false,
        timer: 3000
      },); 
      window.scrollTo(0, 0);
    } else {
      this.getBusinessUserById(this.userInfoId);
    }
  }

  API_BASE_PATH = environment.API_URL;

  getUUID(): string | null {
    var isuuid = localStorage.getItem('UUID');
    return isuuid;
  }
  
  //Phone Pay
  payWithPhonepay = async (price:any, planType:any) => { 
    if(this.businessEmail && this.userInfoId){
      var name= this.firstName +' ' + this.lastName;
      const data = {
        userInfoId: this.userInfoId,
        name: name,
        email:this.businessEmail,
        mobileNumber:this.phoneNumber,
        amount:price,
        planType:planType,
        productId:planType
      }
      try {
        const response = await axios.post(`${this.API_BASE_PATH}phonePay`, data)
        window.location.href = response.data.url;
      } catch (error) {
        //console.log("Error in payment", error)
        Swal.fire({
          title: `Payment has been failed.${error}`,
          icon: "error",
          showConfirmButton: false,
          timer: 2000
        });
      }
    } else {
      Swal.fire({
        title: `Please login and fill all profile information.`,
        icon: "warning",
        showConfirmButton: true,
        confirmButtonText: "Yes",
        showDenyButton: true,
        denyButtonText: `No`
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.router.navigateByUrl('dashboard/profile'); 
        }
      });
    }
  }

  //Razor Pay
  payWithRazorpay(price:any, planType:any) { 
      if(this.businessEmail){
        const options: any = {
          key: environment.RAZORPAY_KEY_ID,
          amount: price * 100, // amount should be in paise format to display Rs 1255 without decimal point
          currency: 'INR',
          name: 'Business in Maharashtra', // company name or product name
          description: 'Selected ' +planType +' Business Plan', // Plan description
          image: './../../assets/images/bim-icon.png', // company logo or product image
          callback_url: "https://eou1xdppp28vbco.m.pipedream.net/",
          prefill: {
            name: this.gender +' ' +this.firstName +' ' + this.lastName,
            email: this.businessEmail,
            contact: this.phoneNumber,
          },
          modal: {
            // We should prevent closing of the form when esc key is pressed.
            escape: false,
          },
          notes: {
              "order_id": 'bimPlanOrder'+Math.random().toString(36).substr(2, 5),
              "payment_type": planType +"Plan"
          },
          theme: {
            color: '#6DB6FD',
          },
        };

        options.handler = (response: any, error: any) => {
          options.response = response;
          //console.log(response.razorpay_payment_id);
          //console.log(response.razorpay_order_id);
          //console.log(response.razorpay_signature)
          
          if (response.error) {
            Swal.fire({
              title: `Payment has been failed.`,
              icon: "error",
              showConfirmButton: false,
              timer: 2000
            });

            this.router.navigateByUrl('price');
          } else {
            Swal.fire({
              title: `Payment has been successfully processed.`,
              icon: "success",
              showConfirmButton: false,
              timer: 3000
            },);
            this.saveAndEmailPricePlan(price, planType, response.razorpay_payment_id, this.businessEmail);
            
            setTimeout(() => {
              this.router.navigateByUrl('dashboard/profile');
            }, 4000);
          }
          // call your backend api to verify payment signature & capture transaction
        };
        options.modal.ondismiss = () => {
          // handle the case when user closes the form while transaction is in progress
          Swal.fire({
            title: `Transaction has been cancelled.`,
            icon: "error",
            showConfirmButton: false,
            timer: 2000
          });
          this.router.navigateByUrl('price');
        };
        const rzp = new this.paymentService.nativeWindow.Razorpay(options);
        rzp.open();

    } else {
      Swal.fire({
        title: `Please login and fill all profile information.`,
        icon: "warning",
        showConfirmButton: true,
        confirmButtonText: "Yes",
        showDenyButton: true,
        denyButtonText: `No`
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.router.navigateByUrl('dashboard/profile'); 
        }
      });
      }
  }

  getBusinessUserById(userInfoId:any): void{
    this.userService.getById(userInfoId).subscribe({
      next: (p) => {
        this.businessUser = p as User;
          if (this.businessUser.data != null && this.businessUser.data.length > 0) {
            this.businessEmail = this.businessUser.data[0].userName;
            this.phoneNumber = this.businessUser.data[0].phoneNumber;
            this.gender = this.businessUser.data[0].gender;
            this.firstName = this.businessUser.data[0].firstName;
            this.lastName= this.businessUser.data[0].lastName;
          }
      }
    })
  }

  saveAndEmailPricePlan(price:any, planType:any, paymentId:any, businessEmail:any) {
    this.emailService.saveAndEmailPricePlan(this.userInfoId, businessEmail, planType, paymentId, price ).subscribe({
      next: (response: any) => {
        if (response) {
          Swal.fire("Plan activated successfully.");
        }
      },
      error: (error: any) => {
        Swal.fire("Email technical issue")
      }
    });
  }
}
